import { useEffect, useState } from 'preact/hooks'

import { getStorageKey, isInIframe, postMessage, Storage } from '../utils'
import { PARENT_WINDOW_SIZE, PublishedEntryMode, TriggerEvent } from '../type'
import { SCREEN_BREAK_POINT } from '../constants'
import { expirePublishedEntry, queryCampaignFields } from 'scripts/service'

export enum MessageActions {
  /**
   * 接收SDK窗口尺寸变化，用于样式响应。
   */
  NOTIFY_PARENT_WINDOW_SIZE = 'NOTIFY_PARENT_WINDOW_SIZE',
  /**
   * 接收SDK过期时间（SDK 20分钟没有响应，自动结束）
   */
  EXPIRE_WIDGET = 'EXPIRE_WIDGET',
  /**
   * 重新渲染组件，目前用于`feedback` 为 `Button`时，每次点击 重新渲染组件触发 题目动画。
   */
  RE_RENDER_PAGE = 'RE_RENDER_PAGE',
  /**
   * 更新`CUSD`，当`campaign type` 为 `Button`时，会预先渲染XForm，但是没有`CUSD`，那么当按钮点击时 会调用 `distribution api` 接口获取到 `CUSD`，发送此事件，更新XForm的`CUSD`。
   */
  UPDATE_XFORM_CUSD = 'UPDATE_XFORM_CUSD',
  WINDOW_CAPTURED = 'WINDOW_CAPTURED',
  WINDOW_CAPTURE_SELECTED = 'WINDOW_CAPTURE_SELECTED',
  GET_FORM_SETTING_BY_TOKEN = 'GET_FORM_SETTING_BY_TOKEN',
}

const useReceiveMessages = (urlToken: string) => {
  const [parentWindowSize, setParentWindowSize] = useState<PARENT_WINDOW_SIZE>(PARENT_WINDOW_SIZE.MD)

  useEffect(() => {
    if (isInIframe()) {
      const handler = (event: MessageEvent) => {
        const { action, payload } = event?.data
        switch (action) {
          case MessageActions.NOTIFY_PARENT_WINDOW_SIZE: {
            setParentWindowSize(payload?.width <= SCREEN_BREAK_POINT ? PARENT_WINDOW_SIZE.SM : PARENT_WINDOW_SIZE.MD)
            break
          }

          case MessageActions.EXPIRE_WIDGET: {
            expirePublishedEntry(urlToken).then()
            postMessage({ name: TriggerEvent.Close, data: { campaignToken: urlToken } })
            break
          }

          case MessageActions.RE_RENDER_PAGE: {
            window.dispatchEvent(new Event(MessageActions.RE_RENDER_PAGE))
            break
          }

          case MessageActions.UPDATE_XFORM_CUSD: {
            queryCampaignFields({
              campaignToken: Storage.getItem(getStorageKey('urlPublishedFormToken', urlToken)),
              cusd: payload.cusd,
              mode: PublishedEntryMode.NORMAL,
              shouldUpdateFormSetting: false,
            }).then()
            break
          }

          case MessageActions.WINDOW_CAPTURE_SELECTED: {
            window.dispatchEvent(new CustomEvent(MessageActions.WINDOW_CAPTURE_SELECTED, { detail: payload }))
            break
          }

          case MessageActions.WINDOW_CAPTURED: {
            window.dispatchEvent(new CustomEvent(MessageActions.WINDOW_CAPTURED))
            break
          }

          default: {
            break
          }
        }
      }

      window.addEventListener('message', handler)
      return () => window.removeEventListener('message', handler)
    }
  }, [])

  useEffect(() => {
    if (!isInIframe()) {
      const handler = () => {
        setParentWindowSize(
          window.document.documentElement.clientWidth <= SCREEN_BREAK_POINT
            ? PARENT_WINDOW_SIZE.SM
            : PARENT_WINDOW_SIZE.MD
        )
      }

      handler()
      window.addEventListener('resize', handler)
      return () => window.removeEventListener('resize', handler)
    }
  }, [])

  return { parentWindowSize }
}

export default useReceiveMessages
